<script>
import jwt_decode from 'jwt-decode';

export default {
    name: "isReator",
    methods: {
        isRealtor() {
            let roles = jwt_decode(localStorage.getItem('access_token')).roles;
            return !Object.values(roles).find(i => i === 'group_adm');
        },
    }
}
</script>

<style scoped>

</style>